import { render, staticRenderFns } from "@/modules/Carrier/templates/carrier-detail.html?vue&type=template&id=cae21d46&scoped=true&"
import script from "@/modules/Carrier/scripts/carrier-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Carrier/scripts/carrier-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Carrier/styles/carrier-detail.scss?vue&type=style&index=0&id=cae21d46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae21d46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
